document.addEventListener('DOMContentLoaded', function () {
    var splide = new Splide('.home-featured .splide.desktop', {
        arrows: false,
        pagination: true,
        perPage: 1,
        type: 'loop',
        autoWidth: false,
        focus: 'center',
        autoplay: true,
        interval: 3000,
        pauseOnHover: false
    });
    splide.mount();
});

document.addEventListener('DOMContentLoaded', function () {
    var splide = new Splide('.home-featured .splide.mobile', {
        arrows: false,
        pagination: true,
        perPage: 1,
        type: 'loop',
        autoWidth: false,
        focus: 'center',
        autoplay: true,
        interval: 3000,
        pauseOnHover: false
    });
    splide.mount();
});

